// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-impact-assessment.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-impact-assessment',
  title: 'Perform AI system impact assessment',
  description:
    'Confirm that an impact assessment is performed for every in-scope AI system before deployment and after material change (ISO/IEC 42001 Cl. 6.1.4 and 8.4, Annex A.5.2–A.5.5). Assessments shall address foreseeable harms, fundamental rights, fairness, safety, autonomy and environmental and societal effects, and their conclusions shall drive risk-treatment decisions. Review the AIIA procedure, the latest completed assessments and evidence that assessment outcomes are tracked through to risk treatment.',
  category: 'risk',
  scfIds: ['SCF-AIG-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'AI impact-assessment procedure is published' },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
